import styled from 'styled-components'

const Container = styled.div`
    max-width: 960px;
    margin: 0 auto;
    padding: 0 .75em;
`

export default Container